import { render, staticRenderFns } from "./AuthenticateDialog.vue?vue&type=template&id=4bb31cef&scoped=true"
import script from "./AuthenticateDialog.vue?vue&type=script&lang=js"
export * from "./AuthenticateDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthenticateDialog.vue?vue&type=style&index=0&id=4bb31cef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb31cef",
  null
  
)

export default component.exports